export function isOwner (ref, id) {
    return ref.where('ownerUid', '==', id)
}


// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/app-core/db-helper.service.ts